// extracted by mini-css-extract-plugin
module.exports = {"example":"e_98","exampleLabel":"e_-8","exampleIntro":"e_a9"};